import { useEffect, useMemo, useState } from 'react'
import type { HomePageLokalLocaleResult } from '../data/HomePageLokalLocaleFragment'
import { contemberLinkToHref } from '../utilities/contemberLinkToHref'
import { Button } from './Button'
import { Container } from './Container'
import { ContemberImage } from './ContemberImage'
import { ContentRenderer } from './ContentRenderer'
import s from './HomePageLokal.module.sass'
import { SiteSwitcher } from './SiteSwitcher'
import { StickyBar } from './StickyBar'

export type HomePageLokalProps = {
	homePageLokal: HomePageLokalLocaleResult
}

export function HomePageLokal(props: HomePageLokalProps) {
	const [imageIndex, setImageIndex] = useState<number | null>(0)
	useEffect(() => {
		if (!props.homePageLokal.ilustration) {
			return
		}
		setImageIndex(Math.floor(Math.random() * props.homePageLokal.ilustration.items.length))
	}, [props.homePageLokal.ilustration])

	const image = useMemo(() => {
		if (imageIndex === null) {
			console.log(imageIndex)
			return null
		}
		return props.homePageLokal.ilustration?.items[imageIndex].image
	}, [imageIndex, props.homePageLokal.ilustration?.items])

	return (
		<div className={s.Wrapper}>
			<div className={s.Header}>
				<div className={s.HeaderIn}>
					<div className={s.LeftColumn}>
						{props.homePageLokal.logo && (
							<div className={s.Logo}>
								<ContemberImage image={props.homePageLokal.logo} objectFit="cover" />
							</div>
						)}
						<h1 className={s.Name}>{props.homePageLokal.title}</h1>
						<div className={s.Text}>{props.homePageLokal.text}</div>
						{props.homePageLokal.button && (
							<Button
								type="link"
								href={contemberLinkToHref(props.homePageLokal.button)}
								theme={props.homePageLokal.root?.theme}
							>
								{props.homePageLokal.button?.title}
							</Button>
						)}
					</div>
					<div className={s.GalleryDesktop}>
						{props.homePageLokal.ilustration && imageIndex !== null && (
							<div
								className={s.IlustrationImageWrapper}
								style={{ '--items-count': `${(props.homePageLokal.gallery?.items ?? []).length}` }}
							>
								<span className={s.IlustrationImage}>
									{image && <ContemberImage image={image} objectFit="contain" layout="fill" />}
								</span>

								{props.homePageLokal.gallery?.items.map(
									(item, index) =>
										item.image && (
											<div key={item.id} className={s.Image} style={{ '--item-counter': `${index}` }}>
												<ContemberImage image={item.image} objectFit="cover" />
											</div>
										),
								)}
							</div>
						)}
						<div className={s.Overlay} />
					</div>
				</div>
			</div>
			<Container size="wide">
				<SiteSwitcher
					title={props.homePageLokal.siteSwitcher?.title}
					link={props.homePageLokal.siteSwitcher?.link}
					theme={props.homePageLokal.siteSwitcher?.theme}
				/>
				{props.homePageLokal.content && (
					<div className={s.Content}>
						<ContentRenderer content={props.homePageLokal.content} />
					</div>
				)}
				{props.homePageLokal.stickyBar && <StickyBar stickyBar={props.homePageLokal.stickyBar} />}
			</Container>
		</div>
	)
}
